import { ImmutableObject } from "../../../../shared/immutableObject";

export class BaseResponse extends ImmutableObject {


}